import SFetch from '@app/utils/sfetch'

export default {
  moveTo(url, body) {
    return SFetch.json(url, { method: 'POST', body }).then((data) =>
      window.Turbolinks.visit(data.redirectTo)
    )
  },
  navigateTo(url) {
    return SFetch.json(url, { method: 'GET' }).then((response) => {
      if (response.redirectTo) {
        window.Turbolinks.visit(response.redirectTo)
      } else {
        return response
      }
    })
  },
}
